import { post } from '@api/api';
import QueryKeys from '@api/index';
import API_ROUTES from '@api/routes';
import { useQuery } from '@tanstack/react-query';
import { useToast } from 'hooks';
import { useContext } from 'react';
import { ToastSeverity } from 'types/toast';
import { AnalyticsKeys, IAnalyticsContext } from '../../../types/analytics';
import AnalyticsContext from './AnalyticsContext';

export const useAnalytics = (key: `${AnalyticsKeys}`) => {
	const { addToast } = useToast();

	const { tenants, timePeriod } =
		useContext<IAnalyticsContext>(AnalyticsContext);

	const route = API_ROUTES.v1.analytics[key];

	const tenantsIds = tenants.map((tenant) => tenant.id);

	return useQuery(
		[QueryKeys.analytics, key, timePeriod, tenantsIds.sort().join('_')],
		async () => {
			try {
				const res = await post(route, {
					tenants: tenantsIds,
					timePeriod
				});
				return res.data;
			} catch (error) {
				addToast({
					content: intl.tr(`analytics.${key}.error`),
					severity: ToastSeverity.Error
				});
			}
			return {};
		},
		{
			staleTime: 100000,
			refetchOnWindowFocus: false
		}
	);
};
